"use client";

import { useEffect, useState } from "react";
import { getConsent, grantConsent, denyConsent } from "@/lib/analytics/mixpanel";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsent() === "unset") {
      const id = setTimeout(() => setVisible(true), 0);
      return () => clearTimeout(id);
    }
  }, []);

  if (!visible) return null;

  function accept() {
    grantConsent();
    setVisible(false);
  }

  function decline() {
    denyConsent();
    setVisible(false);
  }

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      aria-live="polite"
      className="fixed bottom-4 left-4 right-4 z-[9998] mx-auto max-w-lg rounded-xl border border-line bg-surface-2 p-4 shadow-lg sm:left-auto sm:right-6 sm:w-[420px]"
    >
      <p className="text-sm leading-relaxed text-ink-2">
        We use cookies and session recording to improve your experience and measure site performance.
        See our{" "}
        <a href="/privacy-policy" className="underline text-accent hover:no-underline">
          Privacy Policy
        </a>
        .
      </p>
      <div className="mt-4 flex gap-2">
        <button
          onClick={accept}
          className="flex-1 rounded-lg bg-accent px-4 py-2 text-sm font-medium text-white transition-opacity hover:opacity-90"
        >
          Accept all
        </button>
        <button
          onClick={decline}
          className="flex-1 rounded-lg border border-line px-4 py-2 text-sm font-medium text-ink-2 transition-colors hover:border-ink-2"
        >
          Decline
        </button>
      </div>
    </div>
  );
}
